import { render } from "./labsummeryreport.vue?vue&type=template&id=edae6622&scoped=true"
import script from "./labsummeryreport.js?vue&type=script&lang=js"
export * from "./labsummeryreport.js?vue&type=script&lang=js"

import "./labsummeryreport.vue?vue&type=style&index=0&id=edae6622&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edae6622"]])

export default __exports__